/*
 * Shared details for Varshika Jain's book, Read Before They Read.
 * Used by the book page (/read-before-they-read) and the homepage promotion.
 */

export const BOOK_PATH = "/read-before-they-read";
export const BOOK_URL = `https://www.learn2read.co${BOOK_PATH}`;

export const AMAZON_URL = "https://www.amazon.in/dp/9372173843";

// Label for every Amazon purchase button; change it here so they all switch together.
export const AMAZON_CTA_LABEL = "Buy Now";

export const LAUNCH_DATE_LABEL = "20 October 2026";

export type AmazonPlacement =
    | "book_nav"
    | "book_hero"
    | "book_buy_card"
    | "book_closing"
    | "book_sticky_mobile"
    | "homepage_promo"
    | "about_promo"
    | "blog_sidebar"
    | "contact_promo"
    | "demo_thankyou";

/**
 * Records an Amazon button click in GA, only when the visitor accepted
 * non-essential cookies (same rule as page views in App.tsx). Page views are
 * already tracked by App.tsx, so this page adds no page-view tracking.
 */
export const trackAmazonClick = (placement: AmazonPlacement) => {
    if (typeof window === "undefined") return;
    if (!document.cookie.includes("cookieConsentStatus=accepted")) return;
    const gtag = (window as any).gtag;
    if (typeof gtag !== "function") return;
    gtag("event", "amazon_click", {
        book: "read_before_they_read",
        placement,
        link_url: AMAZON_URL,
        transport_type: "beacon",
    });
};
